import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {SearchInput} from '@tickchak/react-share/app';
import {TShow} from '../../../../hooks/useShow';
import SheetShell from '../SheetShell/SheetShell';
import * as css from './AdditionalInfoSheet.css';
import sanitizeHtml from '../../../../library/sanitizeHtml';

interface AdditionalInfoSheetProps {
    additionalInfo: string;
    customFields: {
        title: string;
        value: string;
    }[];
    show: TShow;
}

/* Rendered via a portal to <body>: the card is scaled with a CSS transform, which would otherwise
   become the containing block for this fixed/absolute popup and scale + mis-position it. */
function AdditionalInfoSheet({additionalInfo, customFields, show}: AdditionalInfoSheetProps): React.ReactElement | null {
    const {t} = useTranslation('eTicket');
    const [query, setQuery] = useState('');

    const search = query.trim().toLowerCase();
    const visibleFields = (customFields ?? []).filter(
        ({title, value}) => !search || `${title} ${value}`.toLowerCase().includes(search)
    );

    return (
        <SheetShell show={show} title={t('moreInfo')} data-cy="more-info-sheet">
            {customFields?.length > 0 && (
                <css.search>
                    <SearchInput placeholder={t('search')} onChange={setQuery} onClear={() => setQuery('')} data-cy="more-info-search" />
                </css.search>
            )}
            <css.list>
                {additionalInfo && !search && <css.info dangerouslySetInnerHTML={sanitizeHtml(additionalInfo)} />}
                {visibleFields.map((field) => (
                    <css.item key={field.title}>
                        <css.itemTitle>{field.title}</css.itemTitle>
                        <css.itemValue>{field.value}</css.itemValue>
                    </css.item>
                ))}
            </css.list>
        </SheetShell>
    );
}

export default AdditionalInfoSheet;
